import { axiosGet, axiosPost, axiosPut, axiosGetblob } from '../axios/httpRequest';

/**
 * 提交申请
 */
export const userApplyApi = params => {
    return axiosPost('api/wait_application/v1/wait_application', params);
};

/**
 * 管理员查看申请列表
 */
export const userApplyListApi = params => {
    return axiosGet('api/wait_application/v1/wait_application', params);
};

/**
 * 用户查看查看申请列表
 */
export const userSelfApplyListApi = params => {
    return axiosGet('api/wait_application/v1/wait_application/self', params);
};

/**
 * 申请详情
 */
export const getApplyDetailsApi = params => {
    return axiosGet(`api/wait_application/v1/wait_application/${params.id}`, params);
};

/**
 * 查询审批操作记录
 */
export const getApplyRecordApi = params => {
    return axiosGet(`api/wait_application/v1/wait_application/${params.id}/record`, params);
};

/**
 * 复核
 */
export const putApplyReviewApi = params => {
    return axiosPut(`api/wait_application/v1/wait_application/${params.id}/review`, params);
};

/**
 * 入院审批
 */
export const putApplyAdmissionApi = params => {
    return axiosPut(`api/wait_application/v1/wait_application/${params.id}/admission`, params);
};

/**
 * 轮候审批
 */
export const putApplyApprovalApi = params => {
    return axiosPut(`api/wait_application/v1/wait_application/${params.id}/approval`, params);
};

/**
 * 撤销
 */
export const putApplyCancelApi = params => {
    return axiosPut(`api/wait_application/v1/wait_application/${params.id}/cancel`, params);
};

/**
 * 院前评估审批
 */
export const putApplyEvaluateApi = params => {
    return axiosPut(`api/wait_application/v1/wait_application/${params.id}/evaluate`, params);
};

/**
 * 修改床位区域
 */
export const putApplyModificationApi = params => {
    return axiosPut(`api/wait_application/v1/wait_application/${params.id}/modification`, params);
};

/**
 * 查询复核列表
 */
export const userApplyReviewListApi = params => {
    return axiosGet('api/wait_application/v1/wait_application/review', params);
};

/**
 * 查询轮候申请列表
 */
export const waitApproveListApi = params => {
    return axiosGet('api/wait_application/v1/wait_application/wait_for_approve', params);
};

/**
 * 查询院前评估列表
 */
export const preHospitalListApi = params => {
    return axiosGet('api/wait_application/v1/wait_application/pre_hospital_assessment', params);
};

/**
 * 查询入院审批列表
 */
export const checkInListApi = params => {
    return axiosGet('api/wait_application/v1/wait_application/check_in', params);
};

/**
 * 查询审批操作记录
 */
export const getApproveRecordApi = params => {
    return axiosGet(`api/wait_application/v1/wait_application/${params.id}/record`, params);
};

/**
 * 导出申请记录
 */
export const getDownloadApi = params => {
    return axiosGetblob('api/wait_application/v1/wait_application/excel', params);
};

/**
 * 查询节点审批人员列表
 */
export const getApproveUserApi = params => {
    return axiosGet(`api/wait_application/v1/wait_application/approve_user/${params.node}`, params);
};

/**
 * 恢复流程
 */
export const recoverApi = params => {
    return axiosPut(`api/wait_application/v1/wait_application/${params.id}/recover`, params);
};

/**
 * 挂起流程
 */
export const pauseApi = params => {
    return axiosPut(`api/wait_application/v1/wait_application/${params.id}/pause`, params);
};

/**
 * 时间统计
 */
export const getStatics = params => {
    return axiosGet('api/wait_application/statics', params);
};

export const getDownloadStaticsApi = params => {
    return axiosGetblob('api/wait_application/statics/v1/download', params);
};
